import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { LevelsSubjects } from "./components/LevelsSubjects";
import { Testimonials } from "./components/Testimonials";
import { Partners } from "./components/Partners";
import { Locations } from "./components/Locations";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CallbackButton } from "./components/CallbackButton";
import { LegalMentions, useLegalMentions } from "./components/LegalMentions";
import { EnglishClass } from "./components/EnglishClass";
import { useSeo } from "./hooks/useSeo";
import { Toaster } from "sonner";

const ENGLISH_CLASS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Course",
  name: "English Class — ateliers d'anglais pour enfants",
  description:
    "Ateliers d'anglais ludiques en petit groupe pour les enfants de la maternelle au CM2, à Flexanville et La Queue-lez-Yvelines. 1h de cours par semaine pendant l'année scolaire.",
  inLanguage: "fr-FR",
  teaches: "Anglais oral, vocabulaire et expression pour enfants",
  educationalLevel: "Maternelle au CM2",
  provider: {
    "@type": "EducationalOrganization",
    name: "POTENTIEL+",
    url: "https://potentielplus.net",
  },
  offers: {
    "@type": "Offer",
    price: "390",
    priceCurrency: "EUR",
    category: "Annuel",
    availability: "https://schema.org/InStock",
    url: "https://potentielplus.net/english-class",
  },
  hasCourseInstance: {
    "@type": "CourseInstance",
    courseMode: "Onsite",
    courseWorkload: "PT1H",
    location: {
      "@type": "Place",
      name: "POTENTIEL+ Flexanville",
      address: {
        "@type": "PostalAddress",
        streetAddress: "23 rue de Goupillières",
        addressLocality: "Flexanville",
        postalCode: "78910",
        addressCountry: "FR",
      },
    },
  },
};

// Home Page Component
const HomePage = ({ legalMentions }) => {
  useSeo({
    title: "POTENTIEL+ | Soutien scolaire Yvelines (78)",
    description:
      "Soutien scolaire à Flexanville et La Queue-lez-Yvelines : cours particuliers, cours collectifs, visio et stages de révisions. Du CP à la Terminale, dès 20€/h après crédit d'impôt.",
    path: "/",
  });
  return (
    <>
      <Hero />
      <Services />
      <LevelsSubjects />
      <Testimonials />
      <Partners />
      <About />
      <Locations />
      <Contact />
      <Footer onOpenLegal={legalMentions.open} />
      <CallbackButton />
      <LegalMentions isOpen={legalMentions.isOpen} onClose={legalMentions.close} />
    </>
  );
};

// English Class Page Component
const EnglishClassPage = ({ legalMentions }) => {
  useSeo({
    title: "English Class | Anglais enfants Yvelines",
    description:
      "English Class POTENTIEL+ : ateliers d'anglais ludiques en petit groupe, de la maternelle au CM2, à Flexanville et La Queue-lez-Yvelines. 390€/an, 1h de cours par semaine.",
    path: "/english-class",
    jsonLd: ENGLISH_CLASS_JSONLD,
  });
  return (
    <>
      <EnglishClass />
      <Contact />
      <Footer onOpenLegal={legalMentions.open} />
      <LegalMentions isOpen={legalMentions.isOpen} onClose={legalMentions.close} />
    </>
  );
};

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const legalMentions = useLegalMentions();

  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Navbar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage legalMentions={legalMentions} />} />
            <Route path="/english-class" element={<EnglishClassPage legalMentions={legalMentions} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
